import { render, staticRenderFns } from "./AsignarAulasModal.vue?vue&type=template&id=63b0c418"
import script from "./AsignarAulasModal.vue?vue&type=script&lang=js"
export * from "./AsignarAulasModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports